import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import UptimeChart from './components/UptimeChart/UptimeChart.js'; // Import your chart component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/charts/akademik" element={<UptimeChart />} />
        <Route path="/about" element={<div>test</div>} />
        <Route path="/" element={<div>Home</div>} />
      </Routes>
    </Router>
  );
}

export default App;
